// @ts-nocheck
// BottomNav — 하단 탭바 5개. 순서 확정 [홈·모의투자·복기·커뮤니티·MY] (효신님 2026-09-07 · 복기가 중앙).
// design doc: 2026-09-07-review-tab-stage1-design §0-1·§0-2 (원안 2026-05-22 IA → 2026-06-09 모의투자 허브 → 2026-09-07 금융→복기 교체)
//
// 소속 판정은 tabNavigation.resolveTabRoot 하나로 한다 — 종전엔 이 파일이 그룹 배열 3개를 탭별 OR(startsWith)로
//   계산해 /sim/reflect가 모의투자·복기 둘 다에 켜졌고, useBackTo는 자기 사전을 따로 들고 있었다.
//   금융 탭 하위 화면(/finance·/asset·/budget…)은 그대로 살아 있고 소속만 MY(자산·성향 도구)다.
// (.bottom-nav CSS = src/index.css)
import { useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { trackTabExplorer } from "../ui/achievementEffects";
import { CSIcon } from "../redesign/_components/cs";
import { useKeyboardOpen } from "../hooks/useKeyboardOpen";
import { TABS, resolveTabRoot } from "../lib/tabNavigation";

// 다른 파일이 이 이름들로 import하던 호환 — 정의는 tabNavigation 하나뿐이다.
export { FINANCE_PATHS, MY_PATHS, SIM_PATHS, REVIEW_PATHS } from "../lib/tabNavigation";

export function BottomNav() {
  const { pathname } = useLocation();
  // 키보드가 열려 있으면 탭바를 치운다 — iOS WKWebView는 fixed 요소를 키보드 위로 올려 입력칸을 덮는다
  //   (2026-09-03 댓글칸·매수 CTA·시트 가림의 공통 뿌리. 상세 = hooks/useKeyboardOpen.ts).
  const keyboardOpen = useKeyboardOpen();
  // 현재 경로가 속한 탭 루트 — 정확히 하나(또는 null). 두 탭이 동시에 켜지는 일은 구조적으로 없다.
  const activeRoot = resolveTabRoot(pathname);
  // 탭 탐험가(tab_explorer) — 5탭 전부 방문 시 claim (2026-09-15 모바일 경로 신설 · 웹은 TabTracker).
  //   ⚠ 훅이라 아래 키보드 조기 return보다 위에 둔다(훅 호출 순서 고정).
  useEffect(() => { void trackTabExplorer(activeRoot); }, [activeRoot]);
  if (keyboardOpen) return null;
  return (
    <nav className="bottom-nav" role="navigation" aria-label="주요 메뉴">
      {TABS.map((t) => {
        const on = t.to === activeRoot;
        return (
          <NavLink
            key={t.to}
            to={t.to}
            // 🔴 탭 전환은 replace — push면 탭을 오갈 때마다 히스토리가 무한 누적된다.
            //   실측(2026-07-26 시뮬 계측): 탭 3회 왕복에 state.idx 1→2→3→4·length 2→5.
            //   그래서 복기↔코치기록처럼 두 화면을 오간 뒤 뒤로가기를 누르면 그 왕복이 스택에
            //   그대로 남아 "무한 왕복"으로 되돌아온다(효신님 B-1 증상).
            //   네이티브 앱 관례도 탭 전환은 되돌릴 대상이 아니다 — 각 탭은 형제 루트다.
            replace
            end={t.to === "/"}
            // NavLink 자체 isActive는 접두사 매칭이라 /sim/reflect에서 모의투자를 켠다 → 우리 판정만 쓴다.
            className={() => "bottom-nav__tab" + (on ? " is-active" : "")}
          >
            {() => (
              <>
                <CSIcon name={t.icon} size={22} stroke={on ? 2 : 1.6} />
                <span className="bottom-nav__label">{t.label}</span>
              </>
            )}
          </NavLink>
        );
      })}
    </nav>
  );
}
